module.exports = __webpack_public_path__ + "img/aeroland-app-showcase-image-03.e971edb1.jpg";